module.exports = __webpack_public_path__ + "static/img/before1.90ea708.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/before1.jpg
// module id = 9kyi
// module chunks = 9